import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../redux/settings/selectors";
import { selectTenantsListItems } from "../../../../../redux/tenants/selector";
import { tenants } from "../../../../../redux/tenants/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";

const Tenants = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
	const { header, footer, currency } = result
    const tenantItems = useSelector(selectTenantsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'CompanyName', headerName: 'CompanyName', searchField: 'CompanyName', filter: true,
            filterType: 'text' },
          { field: 'NoOfStores', headerName: 'No Of Stores'},
          { field: 'NoOfWareshouses', headerName: 'No Of Wareshouses ' },
          { field: 'PurchasedDBaaSProgramName', headerName: 'Purchased DBaaSProgram Name' },
          { field: 'NoOfDBaaSSubscriptionsPurchased', headerName: 'No Of DBaaSSubscriptions Purchased ' },
          { field: 'CreatedOnUtc', headerName: 'CreatedOn ' ,isDateValueFormat:true},
          { field: 'ModifiedByUtc', headerName: 'ModifiedBy ' ,isDateValueFormat:true},
          { field: 'ModifiedByUtc', headerName: 'ModifiedBy ' ,isDateValueFormat:true},
         
        ]);
      }

      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(tenants.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/tenants/list`,entity:'tenants',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
          }}))
      }
    
      const handleSelect = (item: any, checked: any) => {
        console.log("Item", checked, item)
      }
    
      const handleSelectAll = (items: any[], checked: any) => {
        console.log("Items count", checked, items?.length)
        console.log('items', items)
      }

      const handleReloadData = () => {
        dispatch(tenants.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/tenants/list`,entity:'tenants',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const additionButtons: any = [
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        // name: 'Reload',
        callback: () => handleReloadData(),
        },
      ];
      const handleEdit=(data: any)=>{
        navigate(`${data?.Id}`)
      }
        
      const fetchTenants=()=>{
        dispatch(tenants.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/tenants/list`,entity:'tenants',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchTenants()
	}, [pageData,pageSize])

	return (
    <>
    {tenantItems?.isLoading ?  <PageLoader />: 
		<Table  enableFilter={true}
    filterTypeLists={filterTypes}
    onSearch={handleSearch} columnData={columnDefs} rowData={tenantItems?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
    paginationData={tenantItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} headingName="Tenants"/>
     
  }
  </> 
	);
};

export default Tenants;


